import template from "./version-number.html";
import { version } from "../../../../package.json";

const VersionNumberComponent = {
  template: template,
  controller: class VersionNumberController {
    /* @ngInject */
    constructor() {
      this.isVisible = process.env.ENV !== "prod";
      this.version = version;
    }
  },
};

export default VersionNumberComponent;
